import React from "react";
import { rarityClass, exactValue } from "@/api";

export const ItemCard = ({ item, variant: variantProp = "normal", onClick, badge, compact, testId }) => {
  if (!item) return null;
  const variant = item.selected_variant || item.variant || variantProp;
  const potion = item.selected_potion || item.potion || "none";
  const v = exactValue(item, variant, potion);
  return (
    <button data-testid={testId || `item-${item.id}`} onClick={onClick} className={`group relative card-cartoon ${rarityClass(item.rarity)} p-2 wiggle text-left ${compact ? "w-20" : "w-32"}`}>
      {badge && <span className="absolute -top-2 -right-2 bg-[#ff5a8a] text-white text-xs rounded-full px-2 py-0.5 shadow-cartoon-sm z-10">{badge}</span>}
      <div className={`relative ${compact ? "h-14" : "h-24"} rounded-2xl bg-gradient-to-br from-[#fff7e8] to-[#ffd1e8] overflow-hidden`}>
        <img src={item.image} alt={item.name} className="w-full h-full object-contain p-1" onError={(e) => { e.target.style.display = "none"; }} />
      </div>
      <div className="mt-1 px-1">
        <div className="text-xs font-semibold truncate" title={item.name}>{item.name}</div>
        <div className="text-[10px] flex items-center justify-between text-[#7649e6]">
          <span className="capitalize truncate">{item.rarity}</span>
          <span className="font-bold">{v.toFixed(2)}</span>
        </div>
      </div>
      {variant !== "normal" && <span className="absolute top-1 left-1 bg-[#7649e6] text-white text-[9px] uppercase rounded-full px-1.5 py-0.5">{variant === "neon" ? "N" : "M"}</span>}
      {item.type === "pets" && potion !== "none" && <span className="absolute top-1 right-1 bg-[#3aa8ff] text-white text-[9px] uppercase rounded-full px-1.5 py-0.5">{potion === "flyride" ? "FR" : potion === "fly" ? "F" : "R"}</span>}
    </button>
  );
};
